import React, { useState, useEffect, useMemo, useCallback } from "react";
import { apiServices } from "../../services/apiServices";
import { Alert } from "@material-ui/lab";
import SyncIcon from "@material-ui/icons/Sync";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import Grid from "@material-ui/core/Grid";
import { Button } from "@dhis2/ui";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";
import OfflineDb from "../../db";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
import _ from "lodash";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/customstyles.css";
import "../../assets/css/theme_blue.css";
import DataTable from "react-data-table-component";

/**
 * error code for offline sync
 *
 * 101: save household
 * 102: save individual
 * 103: get household data
 * 104: update houshold for link contact
 * 105: get inidividual data
 * 106: get household relationships data
 * 107: get all children data
 * 108: update household for vulnerability score
 * 109: get relationship for individual
 * 110: get detail of houshold for index update
 * 111: get detail of household for index update
 * 112: get detail of all children for index update
 * 113: update individual to index
 * 114: get data of existing houshold
 * 115: update existing household
 * 116: adding new hh but fail with error 409 conflict, but more data present in list
 * 117: user creation failed
 */

function Cases() {
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null);
  const [orgDetails, setorgDetails] = React.useState(null);
  const [programData, setprogramData] = useState(null);
  const [offlineRecords, setOfflineRecords] = useState([]);
  const [listOfFields, setListOfFields] = useState(null);
  const [listOfOrg, setListOfOrg] = useState(null);
  const [fieldsToDisplay, setFieldsToDisplay] = useState([]);
  const [fileUploadFieldsIdsList, setFileUploadFieldsIdsList] = useState([]);
  const [currentGeolocation, setCurrentGeoLocation] = useState({
    lat: -8.564650316988002,
    lng: 125.57640845468752,
  });
  const [relationshipId, setrelationshipId] = useState(null);
  const [geolocation, setGeoLocation] = useState(null);
  const [vulAvgScroreFieldId, setvulAvgScroreFieldId] = useState(null);
  const [regType, setRegType] = useState(null);
  const [clientTypeID, setclientTypeID] = useState(null);
  const history = useHistory();
  const { t } = useTranslation();
  const [viewType, setViweType] = useState("card");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [uicID, setUicID] = useState(null);
  const [firstnameid, setfirstname] = useState(null);
  const [regPhoneNumberId, setRegPhoneNumberId] = useState(null);
  const [lastnameid, setlastname] = useState(null);
  const [patientroleid, setpatientroleid] = useState(null);
  const [patienttrackedInstanceId, setpatienttrackedInstanceId] =
    useState(null);
  const [mainaccountId, setmainaccountId] = useState(null);
  const [userGroupId, setuserGroupId] = useState(null);
  const [Configuration, setConfiguration] = React.useState(null);
  const [page, setPage] = useState(1);
  const [noOfPages, setNoOfPages] = useState(0);

  async function getMetaData() {
    let metadata = await OfflineDb.getDataFromPouchDB("metaData");
    setprogramData(metadata.data);
    setListOfFields(metadata.data.programs[0].programTrackedEntityAttributes);
    setListOfOrg(metadata.data.programs[0].organisationUnits);

    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    // console.log("loginDetails", loginDetails);
    setSessionUserBoValue(loginDetails.data);

    let orgDetails = await OfflineDb.getDataFromPouchDB("orgDetails");
    setorgDetails(orgDetails.data);

    let allOfflineRecords = await OfflineDb.getAllEntities();
    setOfflineRecords(allOfflineRecords.rows);
    // console.log("allOfflineRecords>>", allOfflineRecords);

    let geolocationData = await OfflineDb.getDataFromPouchDB("geolocation");
    setGeoLocation(geolocationData.data);

    let configurations = await OfflineDb.getDataFromPouchDB("configurations");
    setConfiguration(configurations.data.configuration);
    setpatientroleid(configurations.data.configuration.patientroleid);
    setpatienttrackedInstanceId(
      configurations.data.configuration.patientTrackedInstanceId
    );
    setmainaccountId(configurations.data.configuration.mainAccountId);
    setuserGroupId(configurations.data.configuration.userGroupId);

    let relationShipId = await OfflineDb.getDataFromPouchDB(
      "relationshipTypeId"
    );

    if (relationShipId.data) {
      setrelationshipId(relationShipId.data);
    } else {
      setrelationshipId("");
    }
  }

  useEffect(() => {
    if (navigator.onLine && navigator.geolocation && geolocation != null) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;

          setCurrentGeoLocation({ lat: latitude, lng: longitude });
        },
        (error) => {
          setCurrentGeoLocation({ lat: geolocation.lat, lng: geolocation.lng });
        },
        { timeout: 10000 }
      );
    } else if (geolocation != null) {
      setCurrentGeoLocation({ lat: geolocation.lat, lng: geolocation.lng });
    }
  }, [geolocation]);

  useEffect(() => {
    getMetaData();
  }, []);

  useEffect(() => {
    if (programData != null) {
      getFileUploadFieldsIds();
      getCustomVariableIds();
    }
  }, [programData]);

  useEffect(() => {
    if (listOfFields != null) {
      let filtteredFields = listOfFields.filter(
        (obj) => obj.displayInList == true
      );
      setFieldsToDisplay(filtteredFields);
    }
  }, [listOfFields]);

  useEffect(() => {
    if (offlineRecords.length > 0 && Configuration != null) {
      setNoOfPages(
        Math.ceil(offlineRecords.length / Configuration.pagination.itemsPerPage)
      );
    }
  }, [offlineRecords, Configuration]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  function getCustomVariableIds() {
    programData.programs[0].programTrackedEntityAttributes.map((fieldName) => {
      // console.log('displayname>>>>', fieldName.trackedEntityAttribute)
      let regField = fieldName.trackedEntityAttribute.description
        ? fieldName.trackedEntityAttribute.description
        : fieldName.trackedEntityAttribute.formName
        ? fieldName.trackedEntityAttribute.formName
        : fieldName.trackedEntityAttribute.displayName;
      if (regField.trim().toLowerCase() == "client type") {
        setclientTypeID(fieldName.trackedEntityAttribute.id);
      }
      if (regField.trim().toLowerCase() == "client uid - mrunner") {
        setUicID(fieldName.trackedEntityAttribute.id);
      }
      if (regField.trim().toLowerCase() == "first name") {
        setfirstname(fieldName.trackedEntityAttribute.id);
      }
      if (regField.trim().toLowerCase() == "surname") {
        setlastname(fieldName.trackedEntityAttribute.id);
      }
      if (regField.trim().toLowerCase() == "phone number (permanent)") {
        setRegPhoneNumberId(fieldName.trackedEntityAttribute.id);
      }
      if (regField.trim().toLocaleLowerCase() == "type of registration") {
        setRegType(fieldName.trackedEntityAttribute.id);
      }
      if (
        regField.trim().toLocaleLowerCase() ==
        "vulnerability score of the household"
      ) {
        setvulAvgScroreFieldId(fieldName.trackedEntityAttribute.id);
      }
    });
  }

  function getFileUploadFieldsIds() {
    programData.programs[0].programTrackedEntityAttributes.map((regField) => {
      if (
        regField.trackedEntityAttribute.valueType.trim() == "IMAGE" ||
        regField.trackedEntityAttribute.valueType.trim() == "FILE_RESOURCE"
      ) {
        fileUploadFieldsIdsList.push(regField.trackedEntityAttribute.id);
        setFileUploadFieldsIdsList(fileUploadFieldsIdsList);
      }
    });

    programData.programs[0].programStages.map((stage) => {
      stage.programStageDataElements.map((de) => {
        if (
          de.dataElement.valueType == "IMAGE" ||
          de.dataElement.valueType == "FILE_RESOURCE"
        ) {
          fileUploadFieldsIdsList.push(de.dataElement.id);
          setFileUploadFieldsIdsList(fileUploadFieldsIdsList);
        }
      });
    });
  }

  const addContact = (id) => {
    if (!navigator.onLine) {
      setGlobalSpinner(true);
      OfflineDb.getSingleEntity(id)
        .then((res) => {
          const activeCaseFormData = {
            formFormat: {
              [clientTypeID]: Configuration.ltbiLinkVariables.contact,
            },
            dhisFormat: null,
          };
          const linkContact = {
            enabled: true,
            linkTrackedEntityInstance: res.trackedEntityInstance
              ? res.trackedEntityInstance
              : id,
          };
          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
          setGlobalSpinner(false);
          history.push("/layout/registration");
        })
        .catch((err) => {
          setGlobalSpinner(false);
          swal({
            title: t("Edit"),
            text: err,
            icon: "error",
            button: t("Close"),
          });
        });
    } else {
      swal({
        title: t("Operation not permitted"),
        text: t(
          "Adding contact is not allowed in online mode for offline Index"
        ),
        icon: "info",
        button: t("Close"),
      });
    }
  };

  const lsitView = (entityObj) => {
    // console.log("fieldsToDisplay", fieldsToDisplay);
    // console.log("entityObj", entityObj);
    return (
      <>
        {fieldsToDisplay.length > 0
          ? fieldsToDisplay.map((eachFields, i) => {
              return (
                <p className="alerts_description_fields" key={i}>
                  {eachFields.trackedEntityAttribute.formName
                    ? eachFields.trackedEntityAttribute.formName
                    : eachFields.trackedEntityAttribute.displayName}{" "}
                  :
                  {entityObj[eachFields.trackedEntityAttribute.id]
                    ? entityObj[eachFields.trackedEntityAttribute.id]
                    : "N/A"}
                </p>
              );
            })
          : null}
      </>
    );
  };
  const caseListView = (entityObj) => {
    // console.log('offline>>111', entityObj.doc.data, JSON.stringify(clientTypeID), entityObj.doc.data[clientTypeID], Configuration.ltbiLinkVariables.index)
    return (
      <Grid item xs={12} sm={6} md={6} className="knowkedgelistcontainer">
        <div className="alertsdetailholder">
          {lsitView(entityObj.doc.data)}
          {/* <p className="alerts_profilebtn_holder caselistviewbtnholder myClientsCaseList hide1">
                        <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn mr-10px">
                            <VisibilityIcon /><span className="ml-10px">{t('See Individual Record')}</span>
                        </Button>
                        <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn mr-10px">
                            <EditIcon /> <span className="ml-10px">{t('New/Update Individual Record')}</span>
                        </Button> */}
          <p className="alerts_profilebtn_holder caselistviewbtnholder myClientsCaseList">
            <Button
              variant="contained"
              color="primary"
              disableElevation
              className="infoviewmorebtn"
              onClick={() => UpdateRecord(entityObj.id)}
            >
              <EditIcon />
            </Button>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              className="infoviewmorebtn"
              onClick={() => DeleteRecord(entityObj.id)}
            >
              <DeleteIcon />
            </Button>
            {Configuration &&
              entityObj.doc.data &&
              entityObj.doc.data[clientTypeID] ==
                Configuration.ltbiLinkVariables.index && (
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  className="infoviewmorebtn ml-10px hide1"
                  onClick={() => addContact(entityObj.id)}
                >
                  <PersonAddIcon />
                  {/* <span className="ml-10px">{t('Add contact')}</span> */}
                </Button>
              )}

            <Button
              variant="contained"
              color="primary"
              disableElevation
              className="infoviewmorebtn"
              onClick={() => SyncSingleRecord(entityObj.id)}
            >
              <SyncIcon />
            </Button>
            {entityObj.doc.formVersion != programData.programs[0].version ? (
              <Button
                variant="contained"
                disableElevation
                className="infoviewmorebtn float-right"
              >
                Outdated Record
              </Button>
            ) : (
              ""
            )}
          </p>
        </div>
      </Grid>
    );
  };

  const deleteofflinedatafromstore = useCallback(() => {
    setGlobalSpinner(true);
    return new Promise(async (resolve, reject) => {
      let offlinestoreurl = `dataStore/offlineSync/${sessionUserBoValue.id}`;
      apiServices
        .deleteFromDataStoreAPI(offlinestoreurl, {})
        .then((res) => {
          // console.log('postAPI>>>', res)
          if (res && res.data && res.data.httpStatusCode) {
            setGlobalSpinner(false);
            resolve(true);
          }
        })
        .catch((err) => {
          // console.log('postAPIerr>>>', err, err.response.data.httpStatusCode)
          setGlobalSpinner(false);
          resolve(true);
        });
    });
  }, [sessionUserBoValue?.id, setGlobalSpinner]); //don't remove ?

  const getFileResourceId = (fileURI) => {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      window.resolveLocalFileSystemURL(
        fileURI,
        function (fileEntry) {
          fileEntry.file(
            function (file) {
              var reader = new FileReader();
              reader.onloadend = async function (e) {
                //console.log("e",file.type)
                var imgBlob = new Blob([this.result], { type: file.type });
                formData.append("file", imgBlob);
                //post formData here
                await apiServices
                  .postAPI("fileResources", formData)
                  .then((res) => {
                    if (res.data) {
                      resolve(res.data.response.fileResource.id);
                    } else {
                      resolve(res);
                    }
                    removeFile(fileURI)
                      .then((res) => console.log(res))
                      .catch((err) => console.log(err));
                  });
              };
              reader.readAsArrayBuffer(file);
            },
            function (err) {
              console.log("err", JSON.stringify(err));
              reject(err);
            }
          );
        },
        function (err) {
          console.log("err", JSON.stringify(err));
          reject(err);
        }
      );
    });
  };
  const getProcessedTEAttributeData = useCallback(
    (doc) => {
      return new Promise(async (resolve, reject) => {
        if (window.cordova) {
          for (let objectKey of Object.keys(doc.data)) {
            if (
              fileUploadFieldsIdsList.indexOf(objectKey) != -1 &&
              doc.data[objectKey]
            ) {
              //upload file and get the resource id
              let resid = await getFileResourceId(doc.data[objectKey]);
              //console.log("resid",resid)

              //update registration object
              doc.registration.attributes.map((attr, idx) => {
                if (attr.attribute == objectKey) {
                  doc.registration.attributes[idx]["value"] = resid;
                }
              });
              //update service object
              if (doc.services.length > 0) {
                doc.services.map((servicearr, serviceIndex) => {
                  servicearr.events.map((eventObj, eventIndex) => {
                    eventObj.dataValues.map((de, deIndex) => {
                      if (de.dataElement == objectKey) {
                        doc.services[serviceIndex]["events"][eventIndex][
                          "dataValues"
                        ][deIndex]["value"] = resid;
                      }
                    });
                  });
                });
              }
            }
          }
          //console.log("doc",doc)

          let instanceBO = doc.registration;
          if (doc.services.length > 0) {
            instanceBO.enrollments[0]["events"] = [];
            doc.services.map((servicearr) => {
              servicearr.events.map((eventObj) => {
                instanceBO.enrollments[0]["events"].push(
                  _.omit(eventObj, ["enrollment", "trackedEntityInstance"])
                );
              });
            });
          }
          resolve(instanceBO);
        } else {
          // console.log("fileUploadFieldsIdsList", fileUploadFieldsIdsList);
          for (let objectKey of Object.keys(doc.data)) {
            // console.log("doc.data[objectKey]", doc.data[objectKey]);
            if (
              fileUploadFieldsIdsList.indexOf(objectKey) != -1 &&
              doc.data[objectKey] &&
              doc.data[objectKey].length > 0
            ) {
              //upload file and get the resource id
              const file = base64ToFile(doc.data[objectKey], "signature.png");

              let resid = await getFileResourceIdNew(file);

              //update registration object
              doc.registration.attributes.map((attr, idx) => {
                if (attr.attribute == objectKey) {
                  doc.registration.attributes[idx]["value"] = resid;
                }
              });
            }

            if (uicID && uicID == objectKey) {
              let UICCode;
              const ouAPI =
                "organisationUnits/" +
                sessionUserBoValue?.organisationUnits?.[0]?.id +
                "?fields=*";

              await apiServices
                .getAPI(ouAPI)
                .then(async (OUStructureParams) => {
                  // console.log("ou", OUStructureParams);
                  if (
                    !OUStructureParams.data.description ||
                    OUStructureParams.data.description == "000000"
                  ) {
                    UICCode = OUStructureParams.data.description = "000001";
                  } else {
                    UICCode = OUStructureParams.data.description =
                      incrementPaddedNumber(OUStructureParams.data.description);
                  }

                  const ouputAPI =
                    "organisationUnits/" +
                    sessionUserBoValue?.organisationUnits?.[0]?.id +
                    "?mergeMode=REPLACE";
                  await apiServices
                    .putAPI(ouputAPI, OUStructureParams.data)
                    .then((res) => {
                      // console.log(res);
                      const orgdata = orgDetails.ancestors || [];
                      const level3Item = orgdata.find(
                        (item) => item.level === 3
                      );
                      const level4Item = orgdata.find(
                        (item) => item.level === 4
                      );

                      if (!level3Item || !level4Item) {
                        console.error(
                          "Missing level3 or level4 organization data"
                        );
                        setGlobalSpinner(false);
                        return;
                      }

                      const UIC = `${level3Item.code}-${level4Item.name
                        .slice(0, 2)
                        .toUpperCase()}-${orgDetails.code}-${UICCode}`;

                      //If you need to store it in state or pass somewhere:

                      // console.log(UIC, "UIC");
                      doc.registration.attributes.map((attr, idx) => {
                        if (attr.attribute == objectKey) {
                          doc.registration.attributes[idx]["value"] = UIC;
                        }
                      });
                    });
                });
            }
          }
          let instanceBO = doc.registration;
          if (doc.services.length > 0) {
            instanceBO.enrollments[0]["events"] = [];
            doc.services.map((servicearr) => {
              servicearr.events.map((eventObj) => {
                instanceBO.enrollments[0]["events"].push(
                  _.omit(eventObj, ["enrollment", "trackedEntityInstance"])
                );
              });
            });
          }
          resolve(instanceBO);
        }
      });
    },
    [
      fileUploadFieldsIdsList,
      getFileResourceId,
      sessionUserBoValue,
      uicID,
      orgDetails?.ancestors,
      orgDetails?.code,
      setGlobalSpinner,
    ]
  );
  const UpdateRecord = useCallback(
    (id) => {
      if (!navigator.onLine) {
        setGlobalSpinner(true);
        OfflineDb.getSingleEntity(id)
          .then((res) => {
            const activeCaseDetails = {
              trackedEntityInstance: id,
              enrollmentId: "",
            };
            const activeCaseFormData = {
              formFormat: res.data,
              dhisFormat: null,
            };
            OfflineDb.setDataIntoPouchDB(
              "activeCaseDetails",
              activeCaseDetails
            );
            OfflineDb.setDataIntoPouchDB(
              "activeCaseFormData",
              activeCaseFormData
            );
            setGlobalSpinner(false);
            history.push("/layout/registration");
          })
          .catch((err) => {
            setGlobalSpinner(false);
            swal({
              title: t("Edit"),
              text: err,
              icon: "error",
              button: t("Close"),
            });
          });
      } else {
        swal({
          title: t("Operation not permitted"),
          text: t("Offline stored data is not possible to edit in online mode"),
          icon: "info",
          button: t("Close"),
        });
      }
    },
    [history, setGlobalSpinner, t]
  );

  const DeleteRecord = useCallback(
    (id) => {
      swal({
        title: t("Delete"),
        text: t("Do you want to delete record?"),
        icon: "warning",
        buttons: [t("No"), t("Yes")],
      }).then((alertRes) => {
        if (alertRes) {
          OfflineDb.deleteEntity(id);
          let indexToRemove = _.findIndex(offlineRecords, {
            id: id,
          });
          offlineRecords.splice(indexToRemove, 1);
          setOfflineRecords([]);
          setOfflineRecords(offlineRecords);
        }
      });
    },
    [offlineRecords, t]
  );

  const SyncSingleRecord = useCallback(
    (id) => {
      if (navigator.onLine) {
        setGlobalSpinner(true);
        OfflineDb.getSingleEntity(id)
          .then(async (res) => {
            let finalObj = { trackedEntityInstances: [] };
            let finalBO = await getProcessedTEAttributeData(res);

            finalObj.trackedEntityInstances.push(finalBO);
            // console.log("finalObj", finalObj);
            apiServices
              .postAPI("trackedEntityInstances", finalObj)
              .then(async (response) => {
                OfflineDb.deleteEntity(id);
                let pendingRecords = _.reject(offlineRecords.rows, { id: id });
                setOfflineRecords([]);
                setOfflineRecords(pendingRecords);
                setGlobalSpinner(false);
                await deleteofflinedatafromstore();
                swal({
                  title: t("Sync"),
                  text: t("Data sync success"),
                  icon: "success",
                  button: t("Close"),
                });
              })
              .catch((err) => setGlobalSpinner(false));
          })
          .catch((err) => {
            setGlobalSpinner(false);
            swal({
              title: t("Sync"),
              text: err,
              icon: "error",
              button: t("Close"),
            });
          });
      } else {
        swal({
          title: t("Network connection issue"),
          text: t("Please make sure your internet connection is working"),
          icon: "info",
          button: t("Close"),
        });
      }
    },
    [
      deleteofflinedatafromstore,
      getProcessedTEAttributeData,
      t,
      offlineRecords.rows,
      sessionUserBoValue,
      setGlobalSpinner,
    ]
  );

  /**
   * FOR INCOMPLETE SYNC SEARCH HOUSEHOLD ID IN LOCALSTORAGE
   */
  const checkParentIdInLocalStorage = (childobj) => {
    return new Promise(async (resolve, reject) => {
      // console.log("checkParentIdInLocalStorage>>", childobj);
      let hhoffdata = JSON.parse(localStorage.getItem("hhoffdata"));
      if (hhoffdata && hhoffdata.length > 0) {
        for (const hh of hhoffdata) {
          // console.log("checkParentIdInLocalStorage>>", hhoffdata, hh);
          if (hh.raw._id == childobj.parentId) {
            resolve(hh.trackedEntityInstance);
          }
        }
        // hhoffdata.map(hh => {
        //     if(hh.raw._id == childobj.parentId) {
        //         resolve(hh.trackedEntityInstance)
        //     }
        // })
        resolve(false);
      } else {
        resolve(childobj.parentId);
      }
    });
  };
  /**
   *
   */

  /**
   * THIS FUNCTION IS USED TO SAVE OFFLINE INDIVIDUAL RECORDS ONLY
   * THIS FUNCTION WILL TRIGGER ONLY WHEN ALL HOUSEHOLD RECORDS HAS BEEN SAVED
   * IMPLEMENTED FOR TIMOR LESTE PROJECT
   */
  const SyncIndividualRecords = async (individualarr) => {
    // console.log("newIndividualArr>>", individualarr);

    setGlobalSpinner(true);
    const orgUnit = sessionUserBoValue.organisationUnits[0].id;
    const trackedEntityType = programData.programs[0].trackedEntityType.id;
    let datasavecount = 0;

    for (const row of individualarr) {
      //individualarr.map(async (row, idx) => {
      let firstnameUId,
        lastnameUId,
        regPhoneNumberUId,
        uicUID = null;
      let orgUnit = row.doc.registration.orgUnit;
      row.doc.registration.attributes.map((attr, idx) => {
        if (attr.attribute == firstnameid) {
          firstnameUId = row.doc.registration.attributes[idx]["value"];
        }
        if (attr.attribute == lastnameid) {
          lastnameUId = row.doc.registration.attributes[idx]["value"];
        }
        if (attr.attribute == uicID) {
          uicUID = row.doc.registration.attributes[idx]["value"];
        }
        if (attr.attribute == regPhoneNumberId) {
          regPhoneNumberUId = row.doc.registration.attributes[idx]["value"];
        }
      });
      let parentid = await checkParentIdInLocalStorage(row.doc);
      // console.log("parentid>>>", parentid);
      let offlineobj = row.doc;

      if (parentid) {
        offlineobj.parentId = parentid;
      }

      let finalBO = await getProcessedTEAttributeData(offlineobj);

      const addIndividual = async () => {
        return new Promise(async (resolve, reject) => {
          await apiServices
            .postAPI("trackedEntityInstances", {
              trackedEntityInstances: [finalBO],
            })
            .then(async (response) => {
              // console.log("indtrackedEntityInstancesresponse>>", response);
              const trackedEntityInstance =
                response.data.response.importSummaries[0].reference;
              // resolve(trackedEntityInstance)
              try {
                const userCreationInput = {
                  userCredentials: {
                    cogsDimensionConstraints: [],
                    catDimensionConstraints: [],
                    username: uicUID,
                    password: "Test@123",
                    userRoles: [{ id: patientroleid }],
                  },
                  surname: lastnameUId,
                  firstName: firstnameUId,
                  phoneNumber: regPhoneNumberUId,
                  organisationUnits: [{ id: orgUnit }],
                  dataViewOrganisationUnits: [{ id: orgUnit }],
                  teiSearchOrganisationUnits: [{ id: orgUnit }],

                  //"userGroups": [{"id": userGroupId}],
                  attributeValues: [
                    {
                      value: trackedEntityInstance,
                      attribute: { id: patienttrackedInstanceId },
                    },
                    { value: true, attribute: { id: mainaccountId } },
                  ],
                };
                // apiServices.postAPI('users', userCreationInput)
                // .then(usersuccess => {

                // }).catch(async (err) => {
                //await saveOfflineErrorToDataStore({...userCreationInput, "error": err, "errorStirng": JSON.stringify(err)}, '117')
                // })
                await saveInLocalStorage({
                  raw: row.doc,
                  final: finalBO,
                  trackedEntityInstance,
                });
              } catch (e) {}
              const programId = programData.programs[0].id;
              const getURL =
                "trackedEntityInstances/" +
                offlineobj.parentId +
                ".json?program=" +
                programId +
                "&fields=*?";
              await apiServices
                .getAPI(getURL)
                .then(async (getParentData) => {
                  const parentAttribute = [];
                  getParentData.data.attributes.map((attributes) => {
                    const obj = {
                      attribute: attributes.attribute,
                      value: attributes.value,
                    };
                    parentAttribute.push(obj);
                  });

                  getParentData.data.relationships.push({
                    from: {
                      trackedEntityInstance: {
                        trackedEntityInstance: offlineobj.parentId,
                      },
                    },
                    to: {
                      trackedEntityInstance: {
                        trackedEntityInstance: trackedEntityInstance,
                      },
                    },
                    relationshipType: relationshipId,
                  });

                  const linkContactJson = {
                    created: moment().format("YYYY-MM-DD"),
                    orgUnit: orgUnit,
                    createdAtClient: moment().format("YYYY-MM-DD"),
                    trackedEntityInstance: offlineobj.parentId,
                    lastUpdated: moment().format("YYYY-MM-DD"),
                    trackedEntityType: trackedEntityType,
                    lastUpdatedAtClient: moment().format("YYYY-MM-DD"),
                    inactive: false,
                    deleted: false,
                    featureType: "NONE",
                    programOwners: [
                      {
                        ownerOrgUnit: orgUnit,
                        program: programId,
                        trackedEntityInstance: offlineobj.parentId,
                      },
                    ],
                    relationships: getParentData.data.relationships,
                    attributes: parentAttribute,
                    geometry: {
                      type: "Point",
                      coordinates: [
                        currentGeolocation.lng,
                        currentGeolocation.lat,
                      ],
                    },
                  };

                  const putURL =
                    "trackedEntityInstances/" + offlineobj.parentId;
                  await apiServices
                    .putAPI(putURL, linkContactJson)
                    .then(async (linkResponse) => {
                      /**
                       * UPDATE HOUSEHOLD VULNERABILITY AVERAGE SCORE
                       */
                      /*if(offlineobj.data[regType] == "Individual") {
                                            await calHouseholdVulnerabiltyScore(offlineobj)
                                        }

                                        if(offlineobj.data[clientTypeID] == 'Index') {
                                            await checkSameHouseHoldMembers(trackedEntityInstance)
                                        }*/

                      OfflineDb.deleteEntity(offlineobj._id);
                      let indexToRemove = _.findIndex(offlineRecords, {
                        id: row.doc._id,
                      });
                      offlineRecords.splice(indexToRemove, 1);
                      setOfflineRecords([]);
                      setOfflineRecords(offlineRecords);
                      datasavecount += 1;
                      resolve(true);
                      if (datasavecount == individualarr.length) {
                        setOfflineRecords([]);
                        localStorage.removeItem("hhoffdata");
                        await deleteofflinedatafromstore();
                        swal({
                          title: t("Sync"),
                          text: t("Data sync success"),
                          icon: "success",
                          button: t("Close"),
                        });
                        setGlobalSpinner(false);
                      }
                    })
                    .catch(async (error) => {
                      // console.log("indparup:", error);
                      setGlobalSpinner(false);
                      //toast.error(JSON.stringify(error));
                      await saveOfflineErrorToDataStore(
                        {
                          ...linkContactJson,
                          apiurl: putURL,
                          error: error,
                          errorStirng: JSON.stringify(error),
                        },
                        "104"
                      );
                      swal({
                        title: "Error",
                        text: "Error code 104",
                        icon: "error",
                        button: "Close",
                      });
                    });
                })
                .catch(async (error) => {
                  // console.log("indparget:", error);
                  setGlobalSpinner(false);
                  //toast.error(JSON.stringify(error));
                  await saveOfflineErrorToDataStore(
                    {
                      apiurl: getURL,
                      error: error,
                      errorStirng: JSON.stringify(error),
                    },
                    "103"
                  );
                  swal({
                    title: "Error",
                    text: "Error code 103",
                    icon: "error",
                    button: "Close",
                  });
                });
            })
            .catch(async (error) => {
              // console.error("indsave:", error);
              // console.log(
              // '.includes("oo")>>',
              // JSON.stringify(error).includes("409")
              // );
              await saveOfflineErrorToDataStore(
                {
                  trackedEntityInstances: [finalBO],
                  error: error,
                  errorStirng: JSON.stringify(error),
                },
                "409"
              );
              if (JSON.stringify(error).includes("409")) {
                OfflineDb.deleteEntity(offlineobj._id);
                let indexToRemove = _.findIndex(offlineRecords, {
                  id: row.doc._id,
                });
                offlineRecords.splice(indexToRemove, 1);
                setOfflineRecords([]);
                setOfflineRecords(offlineRecords);
                datasavecount += 1;
                resolve(true);
                if (datasavecount == individualarr.length) {
                  setOfflineRecords([]);
                  localStorage.removeItem("hhoffdata");
                  await deleteofflinedatafromstore();
                  swal({
                    title: t("Sync"),
                    text: t("Data sync success"),
                    icon: "success",
                    button: t("Close"),
                  });
                  setGlobalSpinner(false);
                }
                return;
              }
              setGlobalSpinner(false);
              //toast.error(JSON.stringify(error));
              await saveOfflineErrorToDataStore(
                {
                  trackedEntityInstances: [finalBO],
                  error: error,
                  errorStirng: JSON.stringify(error),
                },
                "102"
              );
              swal({
                title: "Error",
                text: "Error code 102",
                icon: "error",
                button: "Close",
              });
            });
        });
      };

      const trackedEntityInstance = await addIndividual();

      //})//individualarr.map END
    }
  };

  const saveInLocalStorage = (data) => {
    return new Promise(async (resolve, reject) => {
      // console.log("saveInLocalStorage>>", data);
      let hhoffdata = JSON.parse(localStorage.getItem("hhoffdata"));
      if (hhoffdata) {
        let tempArr = [...hhoffdata];
        tempArr.push(data);
        localStorage.setItem("hhoffdata", JSON.stringify(tempArr));
      } else {
        localStorage.setItem("hhoffdata", JSON.stringify([data]));
      }
      resolve(true);
    });
  };

  const saveOfflineToDataStore = (offlineobjtostore) => {
    return new Promise(async (resolve, reject) => {
      let offlinestoreurl = `dataStore/offlineSync/${sessionUserBoValue.id}`;
      apiServices
        .postAPI(offlinestoreurl, offlineobjtostore)
        .then((res) => {
          // console.log('postAPI>>>', res)
          if (res && res.data && res.data.httpStatusCode) {
            resolve(true);
          }
        })
        .catch((err) => {
          // console.log('postAPIerr>>>', err, err.response.data.httpStatusCode)
          resolve(true);
        });
    });
  };

  const saveOfflineErrorToDataStore = (errorparams, errorstatus) => {
    return new Promise(async (resolve, reject) => {
      let offlinestoreurl = `dataStore/offlineSync/${
        sessionUserBoValue.id
      }_${errorstatus}_${Number.parseFloat(Math.random() * 9999).toFixed(0)}`;
      apiServices
        .postAPI(offlinestoreurl, errorparams)
        .then((res) => {
          // console.log('postAPI>>>', res)
          if (res && res.data && res.data.httpStatusCode) {
            resolve(true);
          }
        })
        .catch((err) => {
          // console.log('postAPIerr>>>', err, err.response.data.httpStatusCode)
          resolve(true);
        });
    });
  };

  const SyncRecords = async () => {
    if (navigator.onLine) {
      setGlobalSpinner(true);
      await saveOfflineToDataStore(offlineRecords);
      let tempIndividualArr = [];
      //let finalObj = {'trackedEntityInstances' : []};
      const allRecords = [...offlineRecords];
      const tempRecords = [...offlineRecords];
      // console.log("allRecords ", allRecords);
      if (allRecords.length == 0) {
        setOfflineRecords([]);
        localStorage.removeItem("hhoffdata");
        await deleteofflinedatafromstore();
        swal({
          title: t("Sync"),
          text: t("Data sync success"),
          icon: "success",
          button: t("Close"),
        });
        setGlobalSpinner(false);
        return;
      }

      let householdcount = tempRecords.filter(
        (row) => !row.doc.hasOwnProperty("parentId")
      );
      if (householdcount.length == 0 && tempRecords.length != 0) {
        SyncIndividualRecords(tempRecords);
        return;
      }

      //allRecords.map(async (row, idx) => {
      for (const row of allRecords) {
        // check from verion and offline data form version
        //console.log(row.doc.formVersion,programData.programs[0].version)
        //console.log("finalBO:",row, row.doc.formVersion, programData.programs[0].version)

        if (row.doc.formVersion == programData.programs[0].version) {
          if (row.doc.parentId) {
            return;
          }

          let finalBO = await getProcessedTEAttributeData(row.doc);

          let firstnameUId,
            lastnameUId,
            regPhoneNumberUId,
            uicUID = null;
          let orgUnit = row.doc.registration.orgUnit;
          row.doc.registration.attributes.map((attr, idx) => {
            if (attr.attribute == firstnameid) {
              firstnameUId = row.doc.registration.attributes[idx]["value"];
            }
            if (attr.attribute == lastnameid) {
              lastnameUId = row.doc.registration.attributes[idx]["value"];
            }
            if (attr.attribute == uicID) {
              uicUID = row.doc.registration.attributes[idx]["value"];
            }
            if (attr.attribute == regPhoneNumberId) {
              regPhoneNumberUId = row.doc.registration.attributes[idx]["value"];
            }
          });
          // console.log("finalBO", finalBO);

          await apiServices
            .postAPI("trackedEntityInstances", {
              trackedEntityInstances: [finalBO],
            })
            .then(async (response) => {
              const trackedEntityInstance =
                response.data.response.importSummaries[0].reference;
              //setGlobalSpinner(false);
              try {
                await saveInLocalStorage({
                  raw: row.doc,
                  final: finalBO,
                  trackedEntityInstance,
                });
              } catch (e) {}

              let newRec = allRecords.filter((oldrec) => {
                if (oldrec.doc.parentId && oldrec.doc.parentId == row.doc._id) {
                  oldrec.doc.parentId = trackedEntityInstance;
                  return oldrec;
                }
              });

              //console.log('newRec>>', newRec)
              tempIndividualArr.push(...newRec);
              // setnewIndividualArr([...newIndividualArr, ...newRec])
              // return
              //console.log('tempIndividualArr>>', tempIndividualArr)
              OfflineDb.deleteEntity(row.doc._id);
              let indexToRemove = _.findIndex(tempRecords, { id: row.doc._id });
              tempRecords.splice(indexToRemove, 1);
              setOfflineRecords([]);
              setOfflineRecords(tempRecords);

              let householdcount = tempRecords.filter(
                (row) => !row.doc.hasOwnProperty("parentId")
              );
              //console.log('householdcount>>', householdcount, tempRecords)
              if (householdcount.length == 0 && tempRecords.length != 0) {
                // console.log("SyncIndividualRecords>>", tempRecords);

                SyncIndividualRecords(tempRecords);
                // }
                return;
              }

              if (tempRecords.length == 0) {
                setOfflineRecords([]);
                localStorage.removeItem("hhoffdata");
                await deleteofflinedatafromstore();
                swal({
                  title: t("Sync"),
                  text: t("Data sync success"),
                  icon: "success",
                  button: t("Close"),
                });
                setGlobalSpinner(false);
              }
            })
            .catch(async (error) => {
              // console.error("parsave:", error, typeof error);
              if (JSON.stringify(error).includes("409")) {
                // OfflineDb.deleteEntity(row.doc._id);
                await saveOfflineErrorToDataStore(
                  {
                    trackedEntityInstances: [finalBO],
                    error: error,
                    errorStirng: JSON.stringify(error),
                  },
                  "409"
                );
                let indexToRemove = _.findIndex(tempRecords, {
                  id: row.doc._id,
                });
                tempRecords.splice(indexToRemove, 1);
                setOfflineRecords([]);
                setOfflineRecords(tempRecords);
                if (tempRecords.length == 0) {
                  OfflineDb.deleteEntity(row.doc._id);
                  setOfflineRecords([]);
                  localStorage.removeItem("hhoffdata");
                  await deleteofflinedatafromstore();
                  swal({
                    title: t("Sync"),
                    text: t("Data sync success"),
                    icon: "success",
                    button: t("Close"),
                  });
                  setGlobalSpinner(false);
                  deleteofflinedatafromstore();
                  return;
                }

                setGlobalSpinner(false);

                await OfflineDb.deleteEntity(row.doc._id);
                //toast.error(JSON.stringify(error));
                swal({
                  title: t("Sync Error"),
                  text: t("Data sync Fail, Error code 116 Index already sync"),
                  icon: "error",
                  button: t("Close"),
                });
                return;
              }

              setGlobalSpinner(false);

              //toast.error(JSON.stringify(error));
              await saveOfflineErrorToDataStore(
                {
                  trackedEntityInstances: [finalBO],
                  error: error,
                  errorStirng: JSON.stringify(error),
                },
                "101"
              );
              swal({
                title: t("Sync Error"),
                text: t("Data sync Fail, Error code 101"),
                icon: "error",
                button: t("Close"),
              });
            });
        } else {
          setGlobalSpinner(false);
          swal({
            title: t("Sync Error"),
            text: t(
              "Offline stored data is out dated, kindly update the data and try again"
            ),
            icon: "error",
            button: t("Close"),
          });
        }
        //});
      }
      // setGlobalSpinner(false)
    } else {
      swal({
        title: t("Network connection issue"),
        text: t("Please make sure your internet connection is working"),
        icon: "info",
        button: t("Close"),
      });
    }
  };
  const removeFile = (path) => {
    return new Promise((resolve, reject) => {
      const filePath = path.substr(0, path.lastIndexOf("/"));

      window.resolveLocalFileSystemURL(
        filePath,
        (dir) => {
          const fileName = path.substr(path.lastIndexOf("/") + 1);
          dir.getFile(
            fileName,
            { create: false },
            (fileEntry) => {
              fileEntry.remove(
                () => {
                  resolve("file removed!");
                },
                (error) => reject("error occurred: " + error.code),
                () => reject("file does not exist")
              );
            },
            (error) => reject(error)
          );
        },
        (error) => reject(error)
      );
    });
  };

  const base64ToFile = (base64String, fileName) => {
    // console.log("base64String", base64String);
    // console.log("fileName", fileName);
    const arr = base64String.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  };

  const getFileResourceIdNew = (file) => {
    return new Promise(async (resolve, reject) => {
      let formData = new FormData();
      if (navigator.onLine) {
        formData.append("file", file);
        await apiServices.postAPI("fileResources", formData).then((res) => {
          if (res.data) {
            resolve(res.data.response.fileResource.id);
          } else {
            resolve(res);
          }
        });
      }
    });
  };

  const incrementPaddedNumber = (input) => {
    const number = parseInt(input, 10) + 1;
    return number.toString().padStart(input.length, "0");
  };

  const offlineData = useMemo(() => {
    return programData && Configuration && offlineRecords.length > 0
      ? offlineRecords.slice(
          (page - 1) * Configuration.pagination.itemsPerPage,
          page * Configuration.pagination.itemsPerPage
        )
      : [];
  }, [programData, Configuration, offlineRecords, page]);

  // console.log("offlineData", offlineData);

  const columns = useMemo(() => {
    const cols = [];
    if (fieldsToDisplay.length > 0) {
      fieldsToDisplay.forEach((f) => {
        cols.push({
          name: f.trackedEntityAttribute.formName,
          selector: f.trackedEntityAttribute.id,
          cell: (row) => {
            if (
              f.trackedEntityAttribute.formName.includes("District") ||
              f.trackedEntityAttribute.formName.includes("State")
            ) {
              return (
                listOfOrg?.find(
                  (o) => o.id === row[f.trackedEntityAttribute.id]
                )?.displayName || row[f.trackedEntityAttribute.id]
              );
            } else {
              return row[f.trackedEntityAttribute.id];
            }
          },
        });
      });
      cols.push({
        name: "Action",
        selector: null,
        width: "200px",
        cell: (row) => (
          <>
            <Button
              variant="contained"
              color="primary"
              component="span"
              disableElevation
              onClick={() => UpdateRecord(row.id)}
            >
              <EditIcon />
            </Button>
            <Button
              variant="contained"
              color="primary"
              component="span"
              disableElevation
              onClick={() => DeleteRecord(row.id)}
              className="ml-10px"
            >
              <DeleteIcon />
            </Button>
            <Button
              variant="contained"
              color="primary"
              component="span"
              disableElevation
              onClick={() => SyncSingleRecord(row.id)}
              className="ml-10px"
            >
              <SyncIcon />
            </Button>
          </>
        ),
      });
    }

    return cols;
  }, [
    fieldsToDisplay,
    SyncSingleRecord,
    UpdateRecord,
    DeleteRecord,
    listOfOrg,
  ]);

  const tableData = useMemo(() => {
    return offlineData.length > 0
      ? [{ ...offlineData?.[0].doc?.data, id: offlineData?.[0].id }]
      : [];
  }, [offlineData]);

  // console.log("columns", columns);
  // console.log("tableData", tableData);
  // console.log("offlineData", offlineData);
  // console.log("sessionUserBoValue", sessionUserBoValue);

  return (
    <>
      {/* <FooterMenu></FooterMenu> */}
      <section
        className="searchcustombg"
        style={{
          backgroundColor: "#fff",
          flexGrow: 1,
          padding: 20,
        }}
      >
        <div className="searchformcontainer">
          {/* <p className="searchformheading">
            <span>
              <Trans>Offline Clients</Trans>
            </span>
            {offlineRecords.length > 0 ? (
              <span className="ml-10px">
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  className="infoviewmorebtn"
                  onClick={SyncRecords}
                >
                  <SyncIcon />
                  <span className="ml-10px">{t("Sync Data")}</span>
                </Button>
              </span>
            ) : null}
          </p> */}
          {/* {programData && Configuration && offlineRecords.length > 0
            ? offlineRecords
                .slice(
                  (page - 1) * Configuration.pagination.itemsPerPage,
                  page * Configuration.pagination.itemsPerPage
                )
                .map((row, i) => {
                  return caseListView(row);
                })
            : null} */}
          {columns.length > 0 && tableData.length > 0 ? (
            <div className="inventoryTable">
              <DataTable
                title="Offline Clients"
                columns={columns}
                data={tableData}
                pagination
                highlightOnHover
                striped
                persistTableHead
                fixedHeader
                actions={
                  offlineRecords.length > 0 ? (
                    <Button
                      variant="contained"
                      color="primary"
                      disableElevation
                      // className="infoviewmorebtn"
                      onClick={SyncRecords}
                    >
                      <SyncIcon />
                      <span className="ml-10px">{t("Sync Data")}</span>
                    </Button>
                  ) : null
                }
                customStyles={{
                  rows: {
                    style: {
                      maxHeight: "48px",
                    },
                  },
                }}
              />
            </div>
          ) : (
            <Alert severity="info">No data to display.</Alert>
          )}
          <ToastContainer
            className="offline-toast"
            position="top-right"
            autoClose={false}
            hideProgressBar={true}
            closeOnClick={false}
          />
          {/* <Pagination
            count={noOfPages}
            page={page}
            onChange={handlePageChange}
            defaultPage={1}
            size="large"
            showFirstButton
            showLastButton
            variant="outlined"
            shape="rounded"
          /> */}
        </div>
      </section>
    </>
  );
}
export default Cases;
